import { useEffect, useState } from "react";

import Action from "./Component/Action";
import Amount from "./Component/Amount";
import ConfirmCancelInvestment from "./Component/ConfirmCancelInvestment";
import ConfirmCloseInvestment from "./Component/ConfirmCloseInvestment";
import FloatingBox from "./Component/FloatingBox";
import { Grid } from "@mui/material";
import { INVESTMENT_ACTION } from "./constants";
import ProfitLost from "./Component/ProfitLost";
import Status from "./Component/Status";
import Table from "components/Table";
import Total from "./Component/Total";
import { getInvestmentPortfolioCurrentlyList } from "store/slices/investment/investmentSlice";
import useDispatch from "hooks/useDispatch";
import useIsMobileView from "hooks/useIsMobileView";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import BottomDrawer from "components/BottomDrawer";
import FluctuationChartAction from "./Component/Fluctuation/FluctuationChartAction";
import FluctuationChart from "./Component/Fluctuation/FluctuationChartWrapper";
import FluctuationChartWrapper from "./Component/Fluctuation/FluctuationChartWrapper";
import { repeat } from "utils/helpers/interval";

const headers = [
  {
    key: "portfolioOwner",
    name: "Name",
    align: "left",
  },
  {
    key: "amount",
    name: "Amount",
    align: "left",
  },
  {
    key: "profitOrLoss",
    name: "Profit/Loss",
    align: "center",
  },
  {
    key: "total",
    name: "Total",
    align: "center",
  },
  {
    key: "stateFirst",
    name: "Status",
    align: "center",
  },
  {
    key: "stateSecond",
    name: "Action",
    align: "center",
  },
  {
    key: "chart",
    name: "Chart",
    align: "center",
  },
];

let getInvestmentPortfolioCurrentlyListInterval = null

function TableFloating({ setCreateInvestmentKey }) {
  const isMobileView = useIsMobileView();

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const investmentPortfolioList = useSelector((state) => state.investment?.investmentPortfolioList?.data)

  const [openAction, setOpenAction] = useState(null)
  const [actionData, setActionData] = useState(null)
  const [chartData, setChartData] = useState(null)
  const [openChart, setOpenChart] = useState(false)

  const handleOpenAction = async (data) => {
    setActionData(data)

    const action = data.stateSecondId

    setOpenAction(action)
  };

  const handleOpenChart = async (data) => {
    setChartData(data)
    setOpenChart(true)
  };

  const handleCloseAction = () => {
    setCreateInvestmentKey((v) => v + 1)
    setActionData(null)

    setOpenAction(null)
  }

  const handleShowDetails = async () => {
    navigate(`/investment-fund/investment-fund-details`);
  };

  useEffect(() => {
    dispatch(getInvestmentPortfolioCurrentlyList())

    clearInterval(getInvestmentPortfolioCurrentlyListInterval);

    getInvestmentPortfolioCurrentlyListInterval = repeat({
      action: () => dispatch(getInvestmentPortfolioCurrentlyList({ coinDestinationId: -1 })),
    });

    return () => {
      clearInterval(getInvestmentPortfolioCurrentlyListInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formattedItemsFloating = investmentPortfolioList?.map(
    (item) => ({
      ...item,
      amount: <Amount data={item} />,
      profitOrLoss: <ProfitLost data={item} />,
      total: <Total data={item} />,
      stateFirst: <Status data={item} />,
      stateSecond: (
        <Action
          data={item}
          handleShowDetails={handleShowDetails}
          handleShowAction={handleOpenAction}
        />
      ),
      chart: (
        <FluctuationChartAction
          data={item}
          handleOpenChart={handleOpenChart}
        />
      ),
    })
  );

  return (
    <>
      {isMobileView ? (
        <Grid container spacing={2}>
          {investmentPortfolioList?.map((floatingFundItem) => (
            <Grid item xs={12}>
              <FloatingBox
                floatingFundItem={floatingFundItem}
                handleShowDetails={handleShowDetails}
                handleShowAction={handleOpenAction}
                handleOpenChart={handleOpenChart}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Table headers={headers} items={formattedItemsFloating} />
      )}

      {
        openAction === INVESTMENT_ACTION.close.id &&
        <ConfirmCloseInvestment
          open={openAction === INVESTMENT_ACTION.close.id}
          data={actionData}
          onClose={handleCloseAction}
        />
      }

      {
        openAction === INVESTMENT_ACTION.cancel.id &&
        <ConfirmCancelInvestment
          open={openAction === INVESTMENT_ACTION.cancel.id}
          data={actionData}
          onClose={handleCloseAction}
        />
      }

      {openChart && (
        <BottomDrawer
          open={openChart}
          onClose={() => {
            setChartData(null)
            setOpenChart(false)
          }}
          dir={"ltr"}
          maxWidth={"md"}
          title={"Fluctuation Chart"}
        >
          <FluctuationChartWrapper itemData={chartData} />
        </BottomDrawer>
      )}
    </>
  );
}

export default TableFloating;
